<template>
	<div class="content-wrapper">
		<nav aria-label="breadcrumb">
			<ol class="breadcrumb">
				<li class="breadcrumb-item">
					<a href="#">
						<i class="fa fa-home"></i>
						Dashboard
					</a>
				</li>
				<li class="breadcrumb-item active">Tally Integration</li>
			</ol>
		</nav>

		<section class="content">
			<div class="container-fluid">
				<div class="row justify-content-md-center">
					<div class="col-sm-12">
						<div class="card">
							<div class="card-header">
								<h3 class="card-title">Tally Integration</h3>
							</div>
							<div class="card-body">
								<div class="row">
									<div class="col-sm-3">
										<div class="form-group">
											<label for="reportType">Report Type</label>
											<select id="reportType" v-model="transaction.report_type"
												class="form-control form-control-sm">
												<option disabled value="">Select Report Type</option>
												<option value="receipt">Receipt</option>
												<option value="payment">Payment</option>
												<option value="buyIn">Chip-Out</option>
												<option value="CashOut">Chip-In</option>
												<option value="Experience_Fees">Settlement</option>
												<option value="Customer">Customers</option>
												<option value="Employee">Employees</option>
											</select>
										</div>
									</div>
									<div class="col-sm-3">
										<div class="form-group">
											<label for="fromDate">From Date Time</label>
											<input type="datetime-local" step="1" id="fromDate"
												v-model="transaction.from_date" class="form-control form-control-sm" />
										</div>
									</div>

									<div class="col-sm-3">
										<div class="form-group">
											<label for="toDate">To Date Time</label>
											<input type="datetime-local" step="1" id="toDate"
												v-model="transaction.to_date" class="form-control form-control-sm" />
										</div>
									</div>
									<div class="col-sm-3" v-can="'change_branch'">
										<div class="form-group">
											<label for="toDate">Branch</label>
											<select class="form-control form-control-sm"
												:class="{ 'is-invalid': errors.branch_id }"
												v-model="transaction.branch_id"
												@change="onBranchChange">
												<option value="">Select Branch</option>
												<option v-for="(branch, key) in branches" :key="key"
													:value="branch.branch_id">
													{{ branch.branch_name }}
												</option>
											</select>
											<span v-if="errors.branch_id" class="invalid-feedback">{{
												errors.branch_id[0] }}</span>
										</div>
									</div>
									<div class="col-sm-3" v-if="transaction.report_type === 'receipt' || transaction.report_type === 'payment'">
										<div class="form-group">
											<label>Payment Mode</label>
											<div class="border rounded p-2 payment-mode-multiselect">
												<div class="form-check" v-for="(payment_mode, key) in payment_modes" :key="key">
													<input type="checkbox" class="form-check-input"
														:value="payment_mode.payment_mode_id"
														v-model="transaction.payment_mode_ids"
														:id="'payment_mode_' + payment_mode.payment_mode_id" />
													<label class="form-check-label" :for="'payment_mode_' + payment_mode.payment_mode_id">
														{{ payment_mode.payment_mode }}
													</label>
												</div>
												<small class="text-muted" v-if="transaction.payment_mode_ids.length">Selected: {{ transaction.payment_mode_ids.length }}</small>
												<small class="text-muted" v-else>All (when none selected)</small>
											</div>
										</div>
									</div>
									<div class="col-sm-2 ">
										<div class="form-group">
											<button v-if="transaction.report_type === 'receipt'"
												class="btn btn-sm btn-primary"
												@click="downloadTransactionDepositDetails"><i
													class="fa fa-download mr-1"></i>Download</button>

											<button v-if="transaction.report_type === 'payment'"
												class="btn btn-sm btn-primary"
												@click="downloadTransactionWithDrawalDetails"><i
													class="fa fa-download mr-1"></i>Download</button>

											<button v-if="transaction.report_type === 'buyIn'"
												class="btn btn-sm btn-primary"
												@click="downloadTransactionChipOutDetails"><i
													class="fa fa-download mr-1"></i>Download</button>

											<button v-if="transaction.report_type === 'CashOut'"
												class="btn btn-sm btn-primary"
												@click="downloadTransactionChipInDetails"><i
													class="fa fa-download mr-1"></i>Download</button>

											<button v-if="transaction.report_type === 'Experience_Fees'"
												class="btn btn-sm btn-primary"
												@click="downloadTransactionExperienceFeesDetails"><i
													class="fa fa-download mr-1"></i>Download</button>

											<button v-if="transaction.report_type === 'Tips'"
												class="btn btn-sm btn-primary"
												@click="downloadTransactionEmployeeTipsDetails"><i
													class="fa fa-download mr-1"></i>Download</button>

											<button v-if="transaction.report_type === 'Employee'"
												class="btn btn-sm btn-primary" @click="downloadEmployeeDetails"><i
													class="fa fa-download mr-1"></i>Download</button>

											<button v-if="transaction.report_type === 'Customer'"
												class="btn btn-sm btn-primary" @click="downloadCustomerDetails"><i
													class="fa fa-download mr-1"></i>Download</button>

										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	name: "TallyIntegration",
	data() {
		return {
			errors: {},
			transaction: {
				from_date: "",
				to_date: "",
				report_type: "",
				branch_id: this.$store.state.user.branch_id,
				payment_mode_ids: []
			},
			branches: [],
			payment_modes: [],
		};
	},
	beforeRouteEnter(to, from, next) {
		next((vm) => {
			vm.getBranches();
			vm.getPaymentModes();
		});
	},
	methods: {
		downloadTransactionDepositDetails() {
			const { from_date, to_date, branch_id, payment_mode_ids } = this.transaction;
			const params = new URLSearchParams();
			params.append('from_date', from_date);
			params.append('to_date', to_date);
			params.append('branch_id', branch_id);
			if (payment_mode_ids && payment_mode_ids.length) {
				payment_mode_ids.forEach(id => params.append('payment_mode_ids[]', id));
			}
			window.open(`${this.$store.getters.apiUrl}downloadTransactionDepositDetails?${params.toString()}`);
		},

		downloadTransactionWithDrawalDetails() {
			const { from_date, to_date, branch_id, payment_mode_ids } = this.transaction;
			const params = new URLSearchParams();
			params.append('from_date', from_date);
			params.append('to_date', to_date);
			params.append('branch_id', branch_id);
			if (payment_mode_ids && payment_mode_ids.length) {
				payment_mode_ids.forEach(id => params.append('payment_mode_ids[]', id));
			}
			window.open(`${this.$store.getters.apiUrl}downloadTransactionWithDrawalDetails?${params.toString()}`);
		},
		downloadTransactionChipOutDetails() {
			const { from_date, to_date, branch_id } = this.transaction;
			window.open(`${this.$store.state.apiUrl}downloadTransactionChipOutDetails?from_date=${from_date}&to_date=${to_date}&branch_id=${branch_id}`);
		},
		downloadTransactionChipInDetails() {
			const { from_date, to_date, branch_id } = this.transaction;
			window.open(`${this.$store.state.apiUrl}downloadTransactionChipInDetails?from_date=${from_date}&to_date=${to_date}&branch_id=${branch_id}`);
		},
		downloadTransactionExperienceFeesDetails() {
			const { from_date, to_date, branch_id } = this.transaction;
			window.open(`${this.$store.state.apiUrl}downloadTransactionExperienceFeesDetails?from_date=${from_date}&to_date=${to_date}&branch_id=${branch_id}`);
		},
		downloadTransactionEmployeeTipsDetails() {
			const { from_date, to_date, branch_id } = this.transaction;
			window.open(`${this.$store.state.apiUrl}downloadTransactionEmployeeTipsDetails?from_date=${from_date}&to_date=${to_date}&branch_id=${branch_id}`);
		},
		downloadEmployeeDetails() {
			const { branch_id } = this.transaction;
			window.open(`${this.$store.state.apiUrl}downloadEmployeeDetails?branch_id=${branch_id}`);
		},
		downloadCustomerDetails() {
			const { branch_id } = this.transaction;
			window.open(`${this.$store.state.apiUrl}downloadCustomerDetails?branch_id=${branch_id}`);
		},

		getBranches() {
			let vm = this;
			vm.$store.dispatch("post", { uri: "getBranches" })
				.then(function (response) {
					vm.branches = response.data.data;
				})
				.catch(function (error) {
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},
		getPaymentModes() {
			let vm = this;
			const branch_id = vm.transaction.branch_id || vm.$store.state.user.branch_id;
			vm.$store.dispatch("post", { uri: "paymentModes", data: { branch_id } })
				.then(function (response) {
					vm.payment_modes = response.data.data;
				})
				.catch(function (error) {
					vm.$store.dispatch("error", (error.response && error.response.data && error.response.data.message) || "Failed to load payment modes");
				});
		},
		onBranchChange() {
			this.transaction.payment_mode_ids = [];
			this.getPaymentModes();
		},
	},
};
</script>

<style scoped>
.form-group {
	margin-bottom: 1rem;
}
.payment-mode-multiselect {
	max-height: 120px;
	overflow-y: auto;
}
</style>
